import styled from 'styled-components';

import { LabelS } from '@sorare/core/src/atoms/typography';
import { Tag } from '@sorare/core/src/atoms/ui/Tag';

const Wrapper = styled(Tag)`
  background-color: rgba(var(--c-rgb-yellow-600), 0.15);
`;

type Props = { nb: number; max: number; opacity?: number };

export const RarityEntries = ({ nb, max, opacity = 1 }: Props) => {
  return (
    <Wrapper $stroke color="white" small style={{ opacity }}>
      <div>
        <LabelS as="span" bold color="var(c--neutral-1000)">
          {nb}
        </LabelS>{' '}
        <LabelS as="span" color="var(--c-neutral-600)">
          / {max}
        </LabelS>
      </div>
    </Wrapper>
  );
};
